import React from 'react';
import CompletedItemIcon from '../../../../assets/images/Completed Item Icon.svg';
import WrongAnswerIcon from '../../../../assets/images/Wrong Answer Icon.svg';
import { CountertopUniversityQuiz } from '../types/CountertopUniversityQuiz';

interface CountertopUniversityQuestionAttemptsProps {
    question: CountertopUniversityQuiz;
    index: number;
    isExpanded: boolean;
    resetQuestionPopup: () => void;
    setIsQuestionPopupVisible: (visible: boolean) => void;
    setCurrentQuestionNumber: (number: number) => void;
    setIsButtonSubmitVisible: (visible: boolean) => void;
    setIsButtonRetryVisible: (visible: boolean) => void;
    setIsButtonDoneVisible: (visible: boolean) => void;
    setIsAnswerADisabled: (disabled: boolean) => void;
    setIsAnswerBDisabled: (disabled: boolean) => void;
    setIsAnswerCDisabled: (disabled: boolean) => void;
    setIsAnswerDDisabled: (disabled: boolean) => void;
    controlResponses: (answer: string, correctAnswer: string) => { isSelectAllApplyExpected: boolean; hasIncorrect: boolean };
    setTextQuestionSummary: (text: string) => void;
    setTextQuestionSummaryCSS: (cssClass: string) => void;
}

const CountertopUniversityQuestionAttempts: React.FC<CountertopUniversityQuestionAttemptsProps> = ({
    question,
    index,
    isExpanded,
    resetQuestionPopup,
    setIsQuestionPopupVisible,
    setCurrentQuestionNumber,
    setIsButtonSubmitVisible,
    setIsButtonRetryVisible,
    setIsButtonDoneVisible,
    setIsAnswerADisabled,
    setIsAnswerBDisabled,
    setIsAnswerCDisabled,
    setIsAnswerDDisabled,
    controlResponses,
    setTextQuestionSummary,
    setTextQuestionSummaryCSS,
}) => {
    return (
        <div className={`answer-attempt-main-container ${isExpanded ? 'answer-attempt-expanded' : 'answer-attempt-collapsed'}`}>
            {question.answerDetails.map((answerDetail, detailIndex) => (
                <div className="answer-attempt-container" key={'q' + detailIndex}>
                    <img
                        className="countertop-university-answer-img"
                        src={answerDetail.isCorrect ? CompletedItemIcon : WrongAnswerIcon}
                        alt="Icon"
                    />
                    <a
                        id={'q' + detailIndex}
                        onClick={() => {
                            resetQuestionPopup();
                            setIsQuestionPopupVisible(true);
                            setCurrentQuestionNumber(index);
                            setIsButtonSubmitVisible(false);
                            setIsButtonRetryVisible(false);
                            setIsButtonDoneVisible(false);
                            setIsAnswerADisabled(true);
                            setIsAnswerBDisabled(true);
                            setIsAnswerCDisabled(true);
                            setIsAnswerDDisabled(true);

                            const result = controlResponses(answerDetail.answer, question.correctAnswer);
                            if (result.isSelectAllApplyExpected) {
                                setTextQuestionSummary('Incorrect, please select all that apply.');
                            }
                            setTextQuestionSummaryCSS(result.hasIncorrect ? 'countertop-question-summary-incorrect' : 'countertop-question-summary-correct');
                        }}
                    >
                        View Attempt {detailIndex + 1}
                    </a>
                    {answerDetail.completedOn && (
                        <p className="countertop-question-completed">
                            &nbsp;&nbsp;Completed {new Date(answerDetail.completedOn).toLocaleString()}
                        </p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default CountertopUniversityQuestionAttempts;